{
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.integrations-service-mcp-request-notification.message-template.in-app.admin-hub-notifications.heading.no-translate": [
    {
      "type": 0,
      "value": "MCP server request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "integrations-service.integrations-service-mcp-request-notification.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "MCP server request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for Android or iOS."
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for Android or iOS."
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copied": [
    {
      "type": 0,
      "value": "Copied!"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copy-consent-link": [
    {
      "type": 0,
      "value": "Copy consent link"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.description": [
    {
      "type": 0,
      "value": "Grant admin consent to the updated SharePoint app so people in your organization can continue using SharePoint and OneDrive links. If you're not a Microsoft Entra admin, copy the consent link and share it with your Microsoft admin."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.grant-consent": [
    {
      "type": 0,
      "value": "Grant Consent"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.remind-me-later": [
    {
      "type": 0,
      "value": "Remind me later"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.title": [
    {
      "type": 0,
      "value": "Action required: Grant consent for SharePoint/OneDrive"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.warning-icon-label": [
    {
      "type": 0,
      "value": "Warning"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.body.no-translate": [
    {
      "type": 0,
      "value": "The connection for *"
    },
    {
      "type": 1,
      "value": "serverName"
    },
    {
      "type": 0,
      "value": "* has expired or needs to be re-authorized."
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.reauth-button.no-translate": [
    {
      "type": 0,
      "value": "Re-authenticate"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.runbook-link.no-translate": [
    {
      "type": 0,
      "value": "Runbook / more information"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.title.no-translate": [
    {
      "type": 0,
      "value": ":warning: Global MCP tool sync cannot run — authentication required"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.subtitle.no-translate": [
    {
      "type": 0,
      "value": "Remote: "
    },
    {
      "type": 1,
      "value": "remoteToolCount"
    },
    {
      "type": 0,
      "value": " tools · YAML baseline: "
    },
    {
      "type": 1,
      "value": "baselineToolCount"
    },
    {
      "type": 0,
      "value": " tools"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.title.no-translate": [
    {
      "type": 0,
      "value": "Global MCP tool sync — "
    },
    {
      "type": 1,
      "value": "serverName"
    }
  ]
}